import { useState } from "react";

import { aPisar, frase } from "../../shared/seleccion";

/* La barra que aparece cuando hay filas marcadas.
 *
 * ── DICE QUÉ VA A PASAR ANTES DE QUE PASE, CON EL NÚMERO ─────────────────
 *
 * «¿Aplicar?» no dice nada. «Poner Movimientos a 43 choferes» sí, y el número
 * es lo único que distingue apretar sobre 3 filas de apretar sobre 224.
 * Escribir 43 filas es lo más destructivo que ofrece esta pantalla y no se
 * deshace con Ctrl+Z.
 *
 * ── Y DICE CUÁNTOS NO SE ESTÁN VIENDO ────────────────────────────────────
 *
 * La selección sobrevive al filtro —para eso se guarda por DNI— así que la
 * barra puede decir «43 marcados» con 3 en pantalla. Sin ese desglose, apretar
 * escribe cuarenta filas que nadie tiene delante.
 *
 * ── LO QUE YA TIENE OTRO VALOR SE AVISA, NO SE PISA EN SILENCIO ──────────
 *
 * Misma regla que `duplicados` y que el cotejo del alta: lo automático avisa y
 * decide la persona. Un hueco se llena sin preguntar; un valor distinto se
 * muestra primero, con cuántos son.
 *
 * ── VA FIJA ABAJO ────────────────────────────────────────────────────────
 *
 * Con 224 filas, una barra que se desplaza con la tabla obliga a subir hasta
 * arriba para aplicar lo que se acaba de marcar abajo.
 */
const BarraSeleccion = ({
  resumen,          // { total, visibles, ocultos }
  filasMarcadas,    // para saber a cuántas les pisaría el valor
  campos,           // [{ campo, etiqueta, opciones: [{ valor, etiqueta }] }]
  onAplicar,        // (campo, valor) => Promise
  onLimpiar,
  guardando,
  resultado,        // { ok: n, fallaron: n } | null
}) => {
  /* Una sola caja con las opciones de TODOS los campos, agrupadas. Con un
   * desplegable por campo la barra crece con cada columna nueva y hay que leer
   * dos controles para entender qué se va a escribir.
   *
   * La clave lleva el campo adelante (`tipo_servicio:mov`) porque los valores
   * solos chocan: el `true` de peligrosas y cualquier otro `true` se verían
   * iguales, y el `select` elegiría el primero. */
  const [elegido, setElegido] = useState("");

  if (!resumen.total) return null;

  const opcion = campos
    .flatMap((c) => c.opciones.map((o) => ({ ...o, campo: c.campo })))
    .find((o) => `${o.campo}:${String(o.valor)}` === elegido);
  const pisa = opcion ? aPisar(filasMarcadas, opcion.campo, opcion.valor) : [];

  return (
    <div className="barra-seleccion" role="region" aria-label="Filas marcadas">
      <div className="bs-cuenta">
        <b>{resumen.total}</b> marcado{resumen.total === 1 ? "" : "s"}
        {/* El número que evita el accidente. */}
        {resumen.ocultos > 0 && (
          <span className="bs-ocultos">
            {" "}· {resumen.ocultos} fuera de lo que estás viendo
          </span>
        )}
      </div>

      <div className="bs-acciones">
        <label className="bs-campo">
          <span className="sr-only">Qué ponerles</span>
          <select
            value={elegido}
            onChange={(e) => setElegido(e.target.value)}
            disabled={guardando}
          >
            <option value="">Elegí qué ponerles…</option>
            {campos.map((c) => (
              <optgroup key={c.campo} label={c.etiqueta}>
                {c.opciones.map((o) => (
                  <option
                    key={`${c.campo}:${String(o.valor)}`}
                    value={`${c.campo}:${String(o.valor)}`}
                  >
                    {o.etiqueta}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </label>

        <button
          type="button"
          className="btn-primario"
          disabled={!opcion || guardando}
          onClick={() => onAplicar(opcion.campo, opcion.valor)}
        >
          {guardando
            ? "Guardando…"
            : opcion
              ? frase(resumen.total, `Poner «${opcion.etiqueta}»`)
              : "Elegí qué ponerles"}
        </button>

        <button type="button" className="btn-suave" onClick={onLimpiar}
                disabled={guardando}>
          Desmarcar todo
        </button>
      </div>

      {/* Lo que se va a pisar. Va ANTES de apretar y con la cuenta: cinco
          filas que ya decían otra cosa es una decisión, no un detalle. */}
      {pisa.length > 0 && !guardando && (
        <p className="bs-aviso">
          ⚠️ {pisa.length} de {resumen.total} ya {pisa.length === 1
            ? "tiene otro valor"
            : "tienen otro valor"} cargado y se va a reemplazar.
        </p>
      )}

      {/* Y SI FALLÓ A LA MITAD, CUÁNTAS ENTRARON. «No se pudo» sobre una
          operación que escribió 30 de 43 manda a repetirla entera. */}
      {resultado && (
        <p className={"bs-aviso" + (resultado.fallaron ? "" : " ok")}>
          {resultado.fallaron
            ? `Se guardaron ${resultado.ok} y fallaron ${resultado.fallaron}. Las que fallaron siguen marcadas.`
            : `Listo: ${resultado.ok} guardado${resultado.ok === 1 ? "" : "s"}.`}
        </p>
      )}
    </div>
  );
};

export default BarraSeleccion;
